import { forwardRef } from 'react';
import type { AppIconComponent, AppIconProps } from './app-icon';

const FLUX_SYMBOL_ASSET = '/brand/flux-symbol-white.svg';

export const FluxBrandIcon: AppIconComponent = forwardRef<
  SVGSVGElement,
  AppIconProps
>(({ size = 24, ...props }, ref) => (
  <svg
    aria-hidden="true"
    fill="none"
    height={size}
    ref={ref}
    viewBox="0 0 197 140"
    width={size}
    {...props}
  >
    <image
      height="140"
      href={FLUX_SYMBOL_ASSET}
      preserveAspectRatio="xMidYMid meet"
      width="197"
    />
  </svg>
));

FluxBrandIcon.displayName = 'FluxBrandIcon';
